import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlockSortAscending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlockSortAscending"><Path d="M10.5 3.5H3.5V10.5H10.5V3.5Z" stroke="currentColor"/><Path d="M10.5 13.5H3.5V20.5H10.5V13.5Z" stroke="currentColor"/><Path d="M17.5 18V7" stroke="currentColor"/><Path d="M13 11L17.5 6.5L22 11" stroke="currentColor"/></CentralIconBase>;
});

export default IconBlockSortAscending;
